import {
  getIpAddressList,
  addIpAddress,
  updateIpDetails,
  deleteIpAddress,
} from "../../api";
import { ipAddressType } from "../type";

export const ipAddressListAction = () => async (dispatch) => {
  try {
    const ipResponse = await getIpAddressList();

    dispatch({
      type: ipAddressType.GET_IP_ADDRESS,
      payload: ipResponse.data.data,
    });
  } catch (error) {
    // console.log(error);
  }
};

export const addIpAddressAction = (reqBody) => async (dispatch) => {
  try {
    const addResponse = await addIpAddress(reqBody);
     // console.log("addResponse.data.status",addResponse.data)
    if (addResponse.data.status === 200) {
      dispatch({
        type: ipAddressType.ADD_IP_ADDRESS,
        payload: addResponse.data.data,
      });
    }else{
      dispatch({
        type: ipAddressType.IP_ADDRESS_ERROR,
        payload: addResponse.data,
      });
    }
  } catch (error) {
    dispatch({
      type: ipAddressType.IP_ADDRESS_ERROR,
      payload: error,
    });
  }
};

export const updateIpAddressAction = (reqBody) => async (dispatch) => {
     
  try {
    const updateResponse = await updateIpDetails(reqBody);

    dispatch({
      type: ipAddressType.UPDATE_IP_ADDRESS,
      payload: updateResponse.data.data,
    });
  } catch (error) {
    // console.log(error);
  }
};

export const deleteIpAddressAction = (reqBody) => async (dispatch) => {
  try {
  
    const deleteResponse = await deleteIpAddress(reqBody);

    dispatch({
      type: ipAddressType.DELETE_IP_ADDRESS,
      payload: deleteResponse.data.data,
    });
  } catch (error) {}
};
